
import { Component, Vue, Prop } from "vue-property-decorator";
import CaseItemM from "./components/CaseItemM.vue";
import { getCaseDetail, getCaseList } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { getArticleJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
import FaqSection from "@/components/FaqSection.vue";
@Component({
  components: {
    CaseItemM,
    Pagination,
    Breadcrumb,
    FaqSection
  }
})
export default class Case extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  total = 1;

  per_page = 12;
  list: any = [];
  page: any = 0;
  id: any = "";
  List = [
    { title: "关于光华", url: "" },
    { title: "客户案例", url: "/case" },
    { title: "案例详情", url: "" }
  ];
  info = {};
  caseFaqs = [
    {
      question: "光华赋能的咨询服务适合什么规模的企业？",
      answer: "光华赋能的咨询陪跑服务适合年营收5000万以上的中大型企业，覆盖制造业、服务业、互联网、金融等多个行业。对于初创企业，推荐先参加光华赋能的公开课程和EMBA项目，建立科学经营的基础认知后再引入咨询服务。"
    },
    {
      question: "一个咨询项目通常需要多长时间？",
      answer: "光华赋能的管理微咨询项目通常为1-3个月，聚焦特定经营问题的诊断与解决方案；咨询陪跑项目通常为6-12个月，提供从战略规划到落地执行的全程陪伴。具体周期根据企业需求和项目复杂度定制。"
    },
    {
      question: "咨询项目的收费模式是怎样的？",
      answer: "光华赋能咨询服务采用项目制收费，根据服务内容、项目周期、投入顾问团队规模等因素综合报价。管理微咨询有标准化套餐，咨询陪跑为定制化报价。可联系光华赋能课程顾问获取具体方案和报价。"
    },
    {
      question: "如何确保咨询方案能够落地执行？",
      answer: "光华赋能采用'咨询+培训+工具+陪跑'的四位一体落地模式：咨询阶段诊断问题并制定方案，培训阶段统一团队认知，工具阶段提供数字化绩效系统支撑，陪跑阶段全程跟进执行并动态调整。同时，光华赋能20000+企业的服务经验积累了大量可复用的落地工具和模板。"
    },
    {
      question: "可以参考同行业的成功案例吗？",
      answer: "可以。光华赋能服务过众多行业的头部企业，在客户案例页面展示了部分代表性案例。如需了解同行业的具体案例和服务细节，可联系课程顾问，在签署保密协议后可获取更详细的案例资料。"
    }
  ];
  created() {
    // 优先从路径参数获取 id，兼容旧的 query 参数形式
    const routeId = this.$route.params.id || this.$route.query.id;
    if (routeId) {
      this.id = routeId as string;
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.page = this.page == 0 ? 1 : this.page;
    this.getCaseList();
    this.getCaseDetail();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.getCaseList();
  }
  async getCaseList() {
    const { data, total } = await getCaseList({
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.list.map((item: any) => {
      item.thumb_url = item.thumb_url
        ? item.thumb_url
        : "/gh_website/img-default.png";
    });
    this.total = total;
  }

  async getCaseDetail() {
    const data = await getCaseDetail({
      id: this.id
    });
    this.info = data;
    // 注入 Article JSON-LD
    if (data && data.title) {
      injectJsonLd(
        "jsonld-article",
        getArticleJsonLd({
          title: data.title,
          description: data.description || data.title,
          image: data.thumb_url || data.pic ? formatUpyunUrl(data.thumb_url || data.pic) : undefined,
          datePublished: data.create_time || data.update_time || undefined,
          dateModified: data.update_time || data.create_time || undefined,
          articleBody:
            typeof data.content === "string"
              ? data.content.replace(/<[^>]+>/g, "").substring(0, 500)
              : undefined
        })
      );
      // 注入 FAQPage JSON-LD
      injectJsonLd("jsonld-case-faq", getFaqJsonLd(this.caseFaqs));
    }
  }
  clickCase(item: any) {
    this.id = item.case_id;
    this.getCaseDetail();
    // this.$router.replace(`/case-detail?id=${item.id}&page=${this.page}`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
